import axios, { AxiosResponse } from 'axios';

type DateTimeString = string;

export interface INavyseniDluh {
    isinjistiny: string;
    cislotranse: string;
    zvysisin: {
        isin: string;
    }[];
}
export const NavyseniDluhGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKdodatek/${id}/zvysdluh`
    }).then((resp: AxiosResponse<INavyseniDluh>) => resp.data);
};
export const NavyseniDluhPut = (id: number | string, data: INavyseniDluh) => {
    return axios({
        method: 'PUT',
        url: `/DOKdodatek/${id}/zvysdluh`,
        data: data
    });
};

export enum ERozsahPPN {
    VSECHNY = 'VSECHNY',
    VYBRANE = 'VYBRANE'
}

export interface INavyseniOstatni {
    pocetcpp: number;
    pocetcpn: number;
    poccpzvys: number;
    zamestakcppn?: boolean;
    rozsahppn?: ERozsahPPN;
}
export const NavyseniOstatniGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKdodatek/${id}/zvysost`
    }).then((resp: AxiosResponse<INavyseniOstatni>) => resp.data);
};
export const NavyseniOstatniPut = (id: number | string, data: INavyseniOstatni) => {
    return axios({
        method: 'PUT',
        url: `/DOKdodatek/${id}/zvysost`,
        data: data
    });
};

export interface INavyseniSicav {
    poccpzvys: number;
    mena: string;
    navakcie: number;
    datkurzu: DateTimeString;
}
export const NavyseniSicavGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOKdodatek/${id}/zvyssicav`
    }).then((resp: AxiosResponse<INavyseniSicav>) => resp.data);
};
export const NavyseniSicavPut = (id: number | string, data: INavyseniSicav) => {
    return axios({
        method: 'PUT',
        url: `/DOKdodatek/${id}/zvyssicav`,
        data: data
    });
};
